var map = {
	"./babylon.svg": "92a3",
	"./calculator.svg": "c8e4",
	"./credit_card.svg": "f188",
	"./eating_together.svg": "ccde",
	"./environment.svg": "55fe",
	"./exploring.svg": "052a",
	"./fingerprint.svg": "edd1",
	"./growing.svg": "9161",
	"./smart_home.svg": "e49c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1544";